import {useFormikContext} from 'formik';
import {LegacyRef} from 'react';
import {BottomSheet} from 'react-spring-bottom-sheet';
import DotsLoading from '../../../../../../components/dotsLoading';
import {IFarmItem} from '../../../../../../services/hookService/getFarmLists/types';
import {FromikType} from '../../../types';

interface ISelectFarmBottomSheet {
  openSelectFarmBottomSheet: boolean;
  SetOpenSelectFarmBottomSheet: React.Dispatch<React.SetStateAction<boolean>>;
  farmListData: IFarmItem[] | undefined;
  loaderRef: LegacyRef<HTMLDivElement> | undefined;
  isFetchingNextPage: boolean;
}

function SelectFarmBottomSheet({
  openSelectFarmBottomSheet,
  SetOpenSelectFarmBottomSheet,
  farmListData,
  loaderRef,
  isFetchingNextPage,
}: ISelectFarmBottomSheet) {
  const {setFieldValue} = useFormikContext<FromikType>();

  return (
    <BottomSheet
      onDismiss={() => SetOpenSelectFarmBottomSheet(false)}
      open={openSelectFarmBottomSheet}
      blocking={true}
      snapPoints={({minHeight, maxHeight}) => [minHeight, maxHeight / 0.6]}
    >
      <div className="flex flex-col px-3 gap-3 pb-3  max-h-[80dvh]">
        {farmListData?.map(item => (
          <span
            key={item.guid}
            onClick={() => {
              setFieldValue('farm', {name: item?.name, guid: item?.guid});
              setFieldValue('existing', item?.masahat);
              SetOpenSelectFarmBottomSheet(false);
            }}
          >
            {item.name}
          </span>
        ))}

        {/* This div acts as a sentinel for triggering infinite scroll */}
        <div ref={loaderRef} className="mt-4 text-center">
          {isFetchingNextPage ? <DotsLoading /> : null}
        </div>
      </div>
    </BottomSheet>
  );
}

export default SelectFarmBottomSheet;
